<template>
  <div>
    <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
      <person-header />
      <div class="personPage">
        <div class="cf w1440">
          <div class="personLeft">
            <personmenu />
          </div>
          <div class="personRight">
            <div class="tit fnt_32">
              <span>{{ globalDataArray.siteTemplateLanguage.personal_information }}</span>
              <a-button class="tit_right" type="primary" @click="onEdit">
                {{ globalDataArray.siteTemplateLanguage.modify_information }}
              </a-button>
            </div>
            <div class="personContent">
              <div class="body">
                <div class="body_title">{{ globalDataArray.siteTemplateLanguage.name_text }}：</div>
                <div class="body_middle">
                  <span class="body_name">{{ person.nickname }}</span>
<!--                  <span class="body_red">实名认证</span>
                  <a-tag class="body_tag">
                    已实名认证
                  </a-tag>
                  <a-tag class="body_tag">
                    已学生认证
                  </a-tag>
                  <span class="body_red">学生认证</span>-->
                </div>
              </div>
              <div class="body">
                <div class="body_title">{{ globalDataArray.siteTemplateLanguage.phone }}：</div>
                <div class="body_middle">
                  <span class="body_name">{{ person.phone }}</span>
                </div>
              </div>
              <div class="body">
                <div class="body_title">{{ globalDataArray.siteTemplateLanguage.site_email }}：</div>
                <div class="body_middle">
                  <span class="body_name">{{ person.email }}</span>
                </div>
              </div>
              <div class="body">
                <div class="body_title">{{ globalDataArray.siteTemplateLanguage.personal_area }}：</div>
                <div class="body_middle">
                  <span class="body_name">{{ person.address }}</span>
                </div>
              </div>
              <div class="body">
                <div class="body_title">{{ globalDataArray.siteTemplateLanguage.team_user_company_name }}：</div>
                <div class="body_middle">
                  <span class="body_name">{{ person.company }}</span>
                </div>
              </div>
              <div class="body">
                <div class="body_title">{{ globalDataArray.siteTemplateLanguage.receiving_address }}：</div>
                <div class="body_middle">
                  <span class="body_name">{{ person.deliveryAddress}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PersonInfoEdit :infoPop.sync="personPop" :person="person" @init="init"/>
  </div>
</template>
<script>
import PersonHeader from '@/views/person/component/PersonHeader.vue'
import { getAdList } from '@/api/api'
import PersonInfoEdit from '@/views/person/component/PersonInfoEdit.vue'
import Cookies from 'js-cookie'
import { getMemberBySourceId } from '@/api/person/person'

export default {
  name: 'PersonalInformation',
  components: { PersonInfoEdit, PersonHeader },
  data() {
    return {
      saitiAccessInfo: {},
      banners: {},
      person: {},
      personInfo: {
        visibility: false
      },
      personPop: false
    }
  },
  mounted() {
    this.getAdList()
    this.init()
  },
  methods: {
    async init() {
      if (Cookies.get('saiti_access_info') != '' && Cookies.get('saiti_access_info') != undefined && Cookies.get('saiti_access_info') != null) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
        console.log(this.saitiAccessInfo, 'llll')
      }
      const res = await getMemberBySourceId()
      if (res.success) {
        this.person = res.result
      }
    },
    getAdList() {
      const that = this
      const adParam = 'alias=person_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          that.banners = res.result[0]
        }
      })
    },
    onEdit() {
      this.personPop = true
    },
    closeModel() {
      this.personInfo.visibility = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/person.css';
.personContent {
  width: 100%;
  background-color: #ffffff;
  border-right: 4px;
  padding: 36px;
  .body {
    border-bottom: 1px solid #E9EDF1;
    margin-bottom: 24px;
    .body_title {
      font-size: 18px;
      line-height: 30px;
      color: #333333;
    }
    .body_middle {
      color: #333333;
      font-size: 14px;
      margin: 6px 0 12px;
      .body_name {
        margin-right: 24px;
      }
      .body_red {
        margin-right: 24px;
        color: #F47E7E;
      }
      .body_tag {
        font-size: 14px;
        color: #1281FF;
        margin-right: 12px;
        padding: 0 12px;
        line-height: 20px;
        background: rgba(18,129,255,0.1);
        border-radius: 11px;
        border: 1px solid #1281FF;
        height: 22px;
      }

    }
  }
}
@media screen and (max-width: 768px) {
  .personContent {
    padding: 20px;
    .body {
      margin-bottom: 18px;
      .body_title {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
.tit_right {
  float: right;
  font-size: 16px;
  line-height: 42px;
  height: 42px;
  border-radius: 8px;
  background: #1281FF;
  color: #fff;
}
</style>
